import { useQuery } from "react-query";

import { getClinicianClientsAsync } from "api/clinician";
import { GET_CLINICIAN_CLIENTS, STALE_TIME_5_MINUTES } from "constants/reactQueryKeys";

/**
 * @description `useGetClinicianClients` is a hook that fetches a clinician's clients using a GET request to
 * `/v2/clinician/[userId]/clients` endpoint.
 * @param {string} userId - The user ID
 * @param {Object} query - The query parameters
 * @returns {Object} The clinician clients
 */
const useGetClinicianClients = (userId, query = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_CLIENTS, userId, query],
    () => getClinicianClientsAsync(userId, query),
    {
      enabled: Boolean(userId),
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return {
    clinicianClients: data?.data || [],
    clinicianClientsLoading: isLoading,
    ...rest,
  };
};

export default useGetClinicianClients;
